<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <base-material-card>
        <template v-slot:heading>
          <div class="display-2">
            {{ titleForm }}
          </div>
        </template>
        <user-form :id="id" :item="item" @saved="onSaved"></user-form>
      </base-material-card>
    </va-aside-layout>
    <base-material-card :icon="resource.icon" :title="title">
      <va-list
        ref="list"
        :filters="filters"
        disable-create-redirect
        @action="onAction"
      >
        <va-data-table
          :fields="fields"
          disable-create-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>
export default {
  props: ["resource", "title"],
  data() {
    return {
      filters: [
        "id",
        "login",
        "password",
        { source: "shiftIni", type: "date" },
        { source: "shiftFin", type: "date" },
        { source: "person_id", type: "select" }
      ],
      fields: [
        { source: "id", sortable: true },
        { source: "login", sortable: true },
        { source: "password", sortable: true },
        { source: "shiftIni", type: "date", sortable: true },
        { source: "shiftFin", type: "date", sortable: true },
        { source: "person_id", type: "select", sortable: true }
      ],
      asideTitle: null,
      titleForm: null,
      id: null,
      item: null,
      show: false
    };
  },
  created() {
    this.item = {
      shiftIni: new Date(),
      shiftFin: new Date()
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onAction({ title, id, item }) {
      this.asideTitle = " ";
      this.titleForm = title;
      this.id = id;
      if (item != null) {
        this.item = item != null ? item : item;
      }
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    }
  }
};
</script>
